import { render, staticRenderFns } from "./extendInfo.vue?vue&type=template&id=c332e78a&scoped=true"
import script from "./extendInfo.vue?vue&type=script&lang=js"
export * from "./extendInfo.vue?vue&type=script&lang=js"
import style0 from "./extendInfo.vue?vue&type=style&index=0&id=c332e78a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c332e78a",
  null
  
)

export default component.exports